export const defaultColors = [
    '#f9ca24',
    '#f0932b',
    '#eb4d4b',
    '#6ab04c',
    '#7ed6df',
    '#e056fd',
    '#686de0',
    '#30336b',
    '#000000',
    '#ffffff',
];
export const defaultSizes = [
    3 /* MarkerSize.s1 */,
    6 /* MarkerSize.s2 */,
    9 /* MarkerSize.s3 */,
    12 /* MarkerSize.s4 */,
    15 /* MarkerSize.s5 */,
];
export const initialSize = defaultSizes[1];
export const initialColor = defaultColors[2];
